module.exports = __webpack_public_path__ + "/static/assets/257e3788c5fbfe56c151a97e97dc20d8.svg";